import { Select } from "../../design/select";
import { Input } from "../../design/input";

interface Props {
  value: { month: number; day: number; time: string };
  onChange: (val: { month: number; day: number; time: string }) => void;
}

const MonthDayTimeInput: React.FC<Props> = ({ value, onChange }) => {
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  return (
    <div className="flex items-center gap-2">
      <Select
        value={value.month}
        onChange={(e) =>
          onChange({ ...value, month: parseInt(e.target.value) })
        }
        className="w-16"
      >
        {months.map((m) => (
          <option key={m} value={m}>
            {m.toString().padStart(2, "0")}
          </option>
        ))}
      </Select>

      <span className="text-muted-foreground">/</span>

      <Select
        value={value.day}
        onChange={(e) => onChange({ ...value, day: parseInt(e.target.value) })}
        className="w-16"
      >
        {days.map((d) => (
          <option key={d} value={d}>
            {d.toString().padStart(2, "0")}
          </option>
        ))}
      </Select>

      <Input
        type="time"
        value={value.time}
        onChange={(e) => onChange({ ...value, time: e.target.value })}
        className="w-[100px]"
      />
    </div>
  );
};

export default MonthDayTimeInput;
